import { transactionClientActionTypes } from "../../actionTypes/transactions/transactionClient.actionTypes";

const initialState = {
  loading: false,
  error: null,
  transactionClient: null,
};

const transactionClientReducer = (state = initialState, action) => {
  switch (action.type) {
    case transactionClientActionTypes.START_ADD_TRANSACTION_CLIENT:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case transactionClientActionTypes.ADD_TRANSACTION_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        transactionClient: action.payload,
      };

    case transactionClientActionTypes.ADD_TRANSACTION_CLIENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to add transaction client.",
      };

    default:
      return state;
  }
};

export default transactionClientReducer;
